// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Hh7P","name":"Header_name__2y2lu","birthday":"Header_birthday__1gvuv","skeleton":"Header_skeleton__3x4sa"};